import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { PieChart } from "@mui/x-charts/PieChart";

const formatTimestamps = (data) =>
  data.map((point) => new Date(point.datetime).toLocaleTimeString());

const renderLineChartCard = (title, data, unit = "", subtitle = "") => {
  const isEmpty = !data || data.length === 0;

  const timestamps = !isEmpty ? formatTimestamps(data) : [];
  const values = !isEmpty
    ? data.map((point) =>
      unit === "MB" ? (point.usage / (1024 * 1024)).toFixed(2) : point.usage
    )
    : [];

  return (
    <div className="cluster_analytics_card">
      <p className="cluster_analytics_card_title">{title}</p>
      {subtitle && (
        <p className="cluster_analytics_card_subtitle">{subtitle}</p>
      )}
      {isEmpty ? (
        <div className="cluster_analytics_card_empty_data">
          Data is not available
        </div>
      ) : (
        <LineChart
          height={250}
          xAxis={[{ scaleType: "point", data: timestamps }]}
          series={[
            {
              data: values,
              label: title,
              showMark: false,
              color: "#1A1A1A",
            },
          ]}
        />
      )}
    </div>
  );
};

const getRandomColor = (index) => {
  const colors = [
    "#000000",
    "#1A1A1A",
    "#333333",
    "#4D4D4D",
    "#666666",
    "#808080",
    "#999999",
    "#B3B3B3",
    "#CCCCCC",
    "#E6E6E6",
  ];

  return colors[index % colors.length];
};

const renderDonutChart = (title, items, getLabel, description = "") => {
  if (!items || items.length === 0) return null;

  const data = items.map((item, i) => ({
    id: i,
    value: 1,
    label: getLabel(item),
    color: getRandomColor(i),
  }));

  const total = items.length;

  return (
    <div className="cluster_analytics_card" style={{ position: "relative" }}>
      <p className="cluster_analytics_card_title">{title}</p>
      {description && (
        <p className="cluster_analytics_card_subtitle">{description}</p>
      )}
      <PieChart
        width={250}
        height={250}
        series={[
          {
            data,
            innerRadius: 70,
            outerRadius: 100,
            paddingAngle: 2,
            cornerRadius: 5,
            cx: 125,
            cy: 125,
          },
        ]}
        slotProps={{ legend: { hidden: true } }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-40%, 90%)",
          fontWeight: "bold",
          fontSize: "14px",
          pointerEvents: "none",
        }}
      >
        {total} {title}
      </div>
    </div>
  );
};

const renderCosts = (title, description, cost) => {
  return (
    <div className="cluster_analytics_card" style={{ position: "relative" }}>
      <p className="cluster_analytics_card_title">{title}</p>
      {description && (
        <p className="cluster_analytics_card_subtitle">{description}</p>
      )}
      {cost == 0 ? (
        <div className="cluster_analytics_card_empty_data">
          No costs available
        </div>
      ) : (
        <div className="cluster_analytics_card_body">${cost}</div>
      )}
    </div>
  );
};

const UsageAnalytics = ({ metrics, records, costMetrics, fetchRecords }) => {
  if (!metrics) return null;

  const { cpu, memory, gpu, nodes = [], pods = [] } = metrics;
  let title_node
  nodes.length > 1 ? title_node = "Nodes" : title_node = "Node"

  let title_pods
  pods.length > 1 ? title_pods = "Pods" : title_pods = "Pod"

  return (
    <div className="cluster_analytics_view" style={{ padding: "1rem" }}>
      {renderLineChartCard("CPU Usage (%)", cpu, "", "Average CPU usage over time.")}
      {renderLineChartCard("Memory Usage (MB)", memory, "MB", "Average memory usage over time.")}
      {renderLineChartCard("GPU Usage (%)", gpu, "", "Average GPU utilization over time.")}
      {renderCosts("Costs", "Estimated cost for the current month.", costMetrics)}

      {renderDonutChart(
        title_node,
        nodes,
        (node) => node.name,
        "A node represents a single machine in the cluster."
      )}
      {renderDonutChart(
        title_pods,
        pods,
        (pod) => pod.name,
        "A pod is the smallest deployable unit in cluster K8S."
      )}
    </div>
  );
};

export default UsageAnalytics;
